export const LOCATION = 'location';
export const SECONDARY_LOCATION = 'secondary_location';

// ani/ali types
export const ALI_UNDERSCORE = 'ali_';
export const LANDLINE = 'Landline';
export const PHASE = 'Phase';
export const VOIP = 'VOIP';
export const OTHER = 'Other';
